export enum CustodyFilterType {
  POSITON_CURRENT = 0,
  POSITON_DAY = 1,
  POSITON_HISTORY = 2,
  POSITION_CREDITED = 0,
  POSITION_PROVISIONED = 1,
  POSITION_SUMARY = 3,
  ASSET_CLASS = 0,
  ASSET_SECTOR = 1
}

export enum CustodyTabEnum {
  BOVESPA = 0,
  BMF = 1,
  PROVENTOS = 2
}

export enum CustodyEarningsFilterType {
  CREDITED = 1,
  PROVISIONED = 2
}

export enum CustodyInputTypeEnum {
  INPUT_OPTIONS = 'input-options',
  INPUT_DATE = 'input-date',
  INPUT_COMPLETE = 'input-complete',
  INPUT_RADIO = 'input-radio',
  INPUT_VIEW_GRAPH = 'input-view-graph',
}
